// extracted by mini-css-extract-plugin
export default {"mediumMobile":"(max-width: 480px)","mediumDesktop":"(max-width: 1180px)","bandWrapper":"Band_bandWrapper__FQ5Pk","bandTitle":"Band_bandTitle__pzDUT"};